module.exports = __webpack_public_path__ + "static/media/concert-1.small.cec21b02.png";